const config = {
	api: {
		server: 'https://api-val.btperf.fr',
		root: "/api/v1",
	},
	doAuth: true,
	federationParameters: {
		ffb: {
			auth: {
				// url: "https://rel-oidc.ffbatiment.fr/connect/authorize",
				// url: "https://dev-oidc.ffbatiment.fr/connect/authorize",
				url: "https://oidc.ffbatiment.fr/connect/authorize",
				clientId: "kerys",
				scope: "openid kerys.api",
				redirectUri: "https://app-val.btperf.fr",
			},
			logo: "logo-federation-francaise-du-batiment.png",
			logoAlt: "Logo Fédération Française du Bâtiment",
			homeUrl: "https://www.ffbatiment.fr",
			// homeUrl: "https://siteinternetrel-ffbatiment.msappproxy.net",
		},
		fntp: {
			auth: {
				url: "https://fntp.my.site.com/services/oauth2/authorize",
				clientId: "3MVG9T46ZAw5GTfVvjz26eqqgJcsYtZpx5bXVtDwkpylckrybCA1h6NsQeM8OOoJrEKvLQjEzu6OHBzFtF770",
				scope: "api refresh_token openid",
				redirectUri: "https://app-val.btperf.fr",
			},
			logo: "logo-federation-nationale-des-travaux-publics.png",
			logoAlt: "Logo Fédération Nationale des Travaux Publics",
			homeUrl: "https://www.fntp.fr",
			// Point de bascule du Lot 2 : URL d'authentification de l'espace adhérent. Une fois
			// renseignée, le bouton FNTP de /login et la route /fntp y renvoient au lieu de
			// l'OAuth2 Salesforce ci-dessus, et le portail ramène l'utilisateur par
			// /sso-fntp/{token}. La remettre à null suffit à revenir en arrière.
			// Préproduction (adresse Vercel provisoire, domaine définitif à venir) :
			portalLoginUrl: "https://fntp-adherents-git-preprod-marketing-dev-webexp-r.vercel.app/login?returnTo=btperf",
		},
	},
	googleAnalytics: "G-ZZZ4X9T9YT",
};

export default config;

